import React from "react";

export default ({ className, width, height }) => (
  <svg
    className={className}
    width={width}
    height={height}
    id="f08a4671-8868-42da-a072-01f8ee40e9a5"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 46.19 47.97"
  >
    <path d="M12.22,4.56c-.18.13,0,.09,0,0" transform="translate(-0.91 -0.02)" fill="#353535" />
    <path
      d="M12.22,4.56l.18-.1a.49.49,0,0,0-.18.1h0"
      transform="translate(-0.91 -0.02)"
      fill="#353535"
    />
    <path
      d="M2.07,16.15h0A.81.81,0,0,0,2.18,16l-.11.12"
      transform="translate(-0.91 -0.02)"
      fill="#353535"
    />
    <path
      d="M11.59,3.51c-1.16,1.65,6.17,10.06,7.84,3.34S15.5-2.1,11.59,3.51"
      transform="translate(-0.91 -0.02)"
      fill="#353535"
    />
    <path
      d="M10.52,3.85s-.31-.36.27-.22l.49,0a1,1,0,0,1,.38,0l.3.16c.18-.15-.7.26,2.14,3.18A6.62,6.62,0,0,0,17,8.45c0-.07.59.25,1.17-.78a7,7,0,0,0,.42-4.83,2.49,2.49,0,0,0-3.74-1.28,8.52,8.52,0,0,0-2.29,1.82c-.08.07,1.61-2.19,3.81-2.26S18.88,4,18.85,4.18s.09-2.58-2-3.1S12.76,2.84,12.54,3A6,6,0,0,1,16.32.86C18.71.79,19.18,3.71,19.23,4s.1-2.45-2-3.22S12.89,2,12.55,2.27A9.84,9.84,0,0,1,14.25,1a3.13,3.13,0,0,0-.7.37A6.73,6.73,0,0,1,14.64.71c.23-.08.47-.13.7-.2a9.18,9.18,0,0,0-2,.79c.11.2-.93.17,2.51-1.08A3.09,3.09,0,0,1,17.4.4a3.79,3.79,0,0,1,2.33,3.38,9.82,9.82,0,0,1-.19,3.05c-.23,1-.67,2.5-2.2,2.82a5.55,5.55,0,0,1-4-1.57C12.27,7,11,6.2,10.52,3.85"
      transform="translate(-0.91 -0.02)"
      fill="#353535"
    />
    <path
      d="M19.77,5.81h0a8.74,8.74,0,0,0,.14-1.42A5.36,5.36,0,0,0,19,1.32,3.25,3.25,0,0,0,16.28,0,4.44,4.44,0,0,0,14,.61h0A4.36,4.36,0,0,1,16.28,0,3.25,3.25,0,0,1,19,1.32a5.34,5.34,0,0,1,.9,3.06,9.38,9.38,0,0,1-.13,1.42h0"
      transform="translate(-0.91 -0.02)"
      fill="#353535"
    />
    <path d="M10.48,13l0,0Z" transform="translate(-0.91 -0.02)" fill="#353535" />
    <path d="M10.45,13.75s0,0,0-.07Z" transform="translate(-0.91 -0.02)" fill="#353535" />
    <path d="M10.26,13.23Z" transform="translate(-0.91 -0.02)" fill="#353535" />
    <path d="M10.24,13.25h0Z" transform="translate(-0.91 -0.02)" fill="#353535" />
    <path d="M10.24,13.23v0Z" transform="translate(-0.91 -0.02)" fill="#353535" />
    <path d="M10.23,13.2Z" transform="translate(-0.91 -0.02)" fill="#353535" />
    <path
      d="M10.23,13.19a.79.79,0,0,0,0-.13l0,0h0l0,.14,0,0Z"
      transform="translate(-0.91 -0.02)"
      fill="#353535"
    />
    <path
      d="M10.16,13.07V13l0,.05h0a.79.79,0,0,1,0,.13l-.05-.08Z"
      transform="translate(-0.91 -0.02)"
      fill="#353535"
    />
    <path
      d="M10.19,12.76c.22.89,0,.2.05.35v0h0c0-.09,0-.15-.05-.2Z"
      transform="translate(-0.91 -0.02)"
      fill="#353535"
    />
    <path
      d="M10.18,12.89s0,.11.05.2l0,0h0l0-.11v0Z"
      transform="translate(-0.91 -0.02)"
      fill="#353535"
    />
    <path d="M10.17,12.94l0,.11,0-.05Z" transform="translate(-0.91 -0.02)" fill="#353535" />
    <polygon
      points="9.31 13.18 9.26 13.1 9.25 13.09 9.25 13.06 9.28 13.09 9.33 13.17 9.33 13.17 9.33 13.18 9.33 13.19 9.33 13.19 9.32 13.18 9.33 13.19 9.33 13.22 9.31 13.18"
      fill="#353535"
    />
    <polygon points="9.25 13.06 9.25 13.09 9.22 13.05 9.22 13.01 9.25 13.06" fill="#353535" />
    <path
      d="M10.14,12.82l0,.12V13l0,0h0v-.07c0,.06,0,0,0-.06"
      transform="translate(-0.91 -0.02)"
      fill="#353535"
    />
    <path d="M10.14,12.75l0,.14v0l0-.12v-.07Z" transform="translate(-0.91 -0.02)" fill="#353535" />
    <polygon points="9.23 12.94 9.26 12.99 9.25 13.06 9.22 13.01 9.23 12.94" fill="#353535" />
    <path
      d="M10.11,12.93c0-.07,0-.12,0-.17v.06c0,.06,0,.12,0,.06V13Z"
      transform="translate(-0.91 -0.02)"
      fill="#353535"
    />
    <polygon
      points="9.2 12.94 9.21 12.91 9.23 12.94 9.23 12.94 9.22 13.01 9.2 12.98 9.2 12.94"
      fill="#353535"
    />
    <polygon points="9.22 13.01 9.22 13.05 9.19 13.02 9.2 12.98 9.22 13.01" fill="#353535" />
    <path
      d="M9.92,12.8l.18.23-.12.78a13.56,13.56,0,0,1-.42,1.64,10.56,10.56,0,0,1-1.28,2.63,7.87,7.87,0,0,1-1.91,2c-2.1,1.5-3.66,1.36-3.43,1.27-.55-.22-.67-1.31-.64-1.95a10.85,10.85,0,0,1,.15-1.54c.11-.66.13-.79.13-.81l-.31-.15.85-.57s0,0,.06-.11a22,22,0,0,1,2-3,4.11,4.11,0,0,1,.38-.45,6.19,6.19,0,0,1,.67-.58h0a2.57,2.57,0,0,1,2.42-.39l.05,0a3.32,3.32,0,0,1,1,.76v0a2.35,2.35,0,0,1,.19.25"
      transform="translate(-0.91 -0.02)"
      fill="#353535"
    />
    <path
      d="M10.15,13.1a2.75,2.75,0,0,1-.05.34c0,.29-.09.46-.09.46s.05-.34.1-.72v-.12Z"
      transform="translate(-0.91 -0.02)"
      fill="#353535"
    />
    <path
      d="M9.73,12.55a3.66,3.66,0,0,1,.37.45v0l-.18-.23a2.35,2.35,0,0,0-.19-.25"
      transform="translate(-0.91 -0.02)"
      fill="#353535"
    />
    <path
      d="M8.73,11.77a2.61,2.61,0,0,1,1,.76,3.32,3.32,0,0,0-1-.76"
      transform="translate(-0.91 -0.02)"
      fill="#353535"
    />
    <path
      d="M6.71,11.83a2,2,0,0,1,2-.08,2.57,2.57,0,0,0-2.42.39l.45-.31"
      transform="translate(-0.91 -0.02)"
      fill="#353535"
    />
    <path
      d="M5.58,12.73a4,4,0,0,1,.67-.58,6.19,6.19,0,0,0-.67.58"
      transform="translate(-0.91 -0.02)"
      fill="#353535"
    />
    <path
      d="M3.68,13.55l-.1.13h0a.58.58,0,0,1,.1-.12"
      transform="translate(-0.91 -0.02)"
      fill="#353535"
    />
    <path
      d="M3.18,16.18a13.47,13.47,0,0,1,2.4-3.45,4.11,4.11,0,0,0-.38.45,22,22,0,0,0-2,3"
      transform="translate(-0.91 -0.02)"
      fill="#353535"
    />
    <path
      d="M3.12,16.29a.54.54,0,0,0,.06-.11c0,.08-.06.12-.06.11"
      transform="translate(-0.91 -0.02)"
      fill="#353535"
    />
    <path d="M3.09,15.82l0,0Z" transform="translate(-0.91 -0.02)" fill="#353535" />
    <path
      d="M10.24,13.25v0h0ZM3.12,15.79a11.11,11.11,0,0,1,3.46-4.18,2.59,2.59,0,0,1,3.21.56,5.18,5.18,0,0,1,.69.79c0,.32,0,.58,0,.72s0,.1,0,.07v-.07c.07-.25.33-1-.11-1.13A3.3,3.3,0,0,0,7.47,11C4.85,11.58,3.4,14.7,3,15c0,0,1-1.6,1.4-2.07l-.57.68a11,11,0,0,1,.92-1.21c.22-.2.42-.41.65-.58a15.58,15.58,0,0,0-1.65,1.63c.26-.32.84-1,2.06-2.2a3.71,3.71,0,0,1,1.74-.66c1-.13,3.51.74,3.44,3a11.61,11.61,0,0,1-3.5,7.06c-1.24,1-2.61,2.1-4.78,1.88A2.73,2.73,0,0,1,.94,20a11.52,11.52,0,0,1,.18-3s-.29-.28.28-.11l.48.07.39-.07.31.15s0,.15-.13.81a10.85,10.85,0,0,0-.15,1.54c0,.64.09,1.73.64,1.95-.23.09,1.33.23,3.43-1.27a7.87,7.87,0,0,0,1.91-2,10.56,10.56,0,0,0,1.28-2.63A13.56,13.56,0,0,0,10,13.81L10.1,13l0,0v.12c0,.38-.09.63-.1.72s0-.17.09-.46a2.75,2.75,0,0,0,.05-.34v0l.05.08,0,0v0h0l0,0h0l0-.14v0c0-.15.17.54-.05-.35v.13l0-.14v0c0,.05,0,.1,0,.17l-.06-.09A2.8,2.8,0,0,0,7.28,11.5c-2.35.78-3.81,3.91-4.16,4.29"
      transform="translate(-0.91 -0.02)"
      fill="#353535"
    />
    <path
      d="M9.37,13.79a12.85,12.85,0,0,1-1.5,4.12c-.12.2-.24.39-.37.57a6.39,6.39,0,0,0,.36-.58,12.49,12.49,0,0,0,1.5-4.11Z"
      transform="translate(-0.91 -0.02)"
      fill="#353535"
    />
    <path
      d="M7.29,18.75a7.59,7.59,0,0,1-1.86,1.69h0a8,8,0,0,0,1.86-1.69"
      transform="translate(-0.91 -0.02)"
      fill="#353535"
    />
    <polygon points="4.53 20.42 4.52 20.42 4.52 20.42 4.53 20.42" fill="#353535" />
    <rect x="4.52" y="20.42" fill="#353535" />
    <path
      d="M5.42,20.44h0A10.45,10.45,0,0,1,4,21.17l.17-.07a11.85,11.85,0,0,0,1.29-.66"
      transform="translate(-0.91 -0.02)"
      fill="#353535"
    />
    <path
      d="M4,21.17a2.93,2.93,0,0,1-.52.18L4,21.17"
      transform="translate(-0.91 -0.02)"
      fill="#353535"
    />
    <path
      d="M2.82,21.45a2.42,2.42,0,0,0,.62-.1,2.42,2.42,0,0,1-.62.1.8.8,0,0,1-.6-.21.82.82,0,0,0,.6.21"
      transform="translate(-0.91 -0.02)"
      fill="#353535"
    />
    <path
      d="M2.23,17.15h0s0,.19-.1.46c.06-.27.1-.43.1-.46"
      transform="translate(-0.91 -0.02)"
      fill="#353535"
    />
    <path
      d="M2,20.88a.9.9,0,0,0,.15.31A.75.75,0,0,1,2,20.88"
      transform="translate(-0.91 -0.02)"
      fill="#353535"
    />
    <path
      d="M2,20.66a.66.66,0,0,0,0,.21.66.66,0,0,1,0-.21"
      transform="translate(-0.91 -0.02)"
      fill="#353535"
    />
    <path
      d="M2,20.54s0,.08,0,.12a.49.49,0,0,1,0-.12,6.52,6.52,0,0,1-.07-1A8.52,8.52,0,0,1,2,18.26a10,10,0,0,0-.1,1.31,6.52,6.52,0,0,0,.07,1"
      transform="translate(-0.91 -0.02)"
      fill="#353535"
    />
    <path d="M10,13.23a.32.32,0,0,1,0,.08h0v0Z" transform="translate(-0.91 -0.02)" fill="#353535" />
    <polygon points="9.12 13.27 9.12 13.29 9.11 13.24 9.12 13.27" fill="#353535" />
    <polygon points="9.1 13.22 9.11 13.24 9.1 13.23 9.1 13.22" fill="#353535" />
    <polygon points="9.1 13.23 9.11 13.24 9.1 13.24 9.1 13.23" fill="#353535" />
    <rect x="9.1" y="13.22" fill="#353535" />
    <polygon points="9.1 13.22 9.1 13.23 9.1 13.22 9.1 13.22" fill="#353535" />
    <polygon points="9.1 13.22 9.1 13.23 9.1 13.24 9.09 13.22 9.1 13.22" fill="#353535" />
    <path d="M10,13.24Z" transform="translate(-0.91 -0.02)" fill="#353535" />
    <path
      d="M10,13c0,.1,0,.18,0,.22s0-.11,0-.21Z"
      transform="translate(-0.91 -0.02)"
      fill="#353535"
    />
    <polygon points="9.05 12.99 9.05 13 9.05 12.99 9.05 12.99" fill="#353535" />
    <polygon
      points="9.04 13.04 9.05 12.99 9.05 13 9.05 13.04 9.04 13.14 9.04 13.13 9.04 13.04"
      fill="#353535"
    />
    <polygon
      points="9.05 13.15 9.09 13.22 9.04 13.15 9.04 13.15 9.04 13.14 9.05 13.15"
      fill="#353535"
    />
    <rect x="9.03" y="13.14" width="0.01" height="0.01" fill="#353535" />
    <path
      d="M9.93,13.25v-.09h0v.09a2.44,2.44,0,0,1-.06.37h0v0l0-.07a1.78,1.78,0,0,1,0-.28"
      transform="translate(-0.91 -0.02)"
      fill="#353535"
    />
    <path
      d="M9.62,12.72a4.74,4.74,0,0,1,.32.43h0c-.09-.13-.19-.28-.32-.44l-.31-.34c.12.12.22.24.31.34"
      transform="translate(-0.91 -0.02)"
      fill="#353535"
    />
    <path
      d="M8,11.52a3.56,3.56,0,0,1,1.31.86A3.65,3.65,0,0,0,8,11.52"
      transform="translate(-0.91 -0.02)"
      fill="#353535"
    />
    <path
      d="M7.27,11.4a2.24,2.24,0,0,1,.73.12,2.54,2.54,0,0,0-.73-.12H7.12l-.18,0,.18,0h.15"
      transform="translate(-0.91 -0.02)"
      fill="#353535"
    />
    <path
      d="M4.74,12.71a4.25,4.25,0,0,1,2.2-1.27,4.25,4.25,0,0,0-2.2,1.27"
      transform="translate(-0.91 -0.02)"
      fill="#353535"
    />
    <path d="M4.45,13l.29-.3-.29.3" transform="translate(-0.91 -0.02)" fill="#353535" />
    <path
      d="M3.93,13.65C3.41,14.33,3,15,2.84,15.26h0c.2-.29.57-.93,1.1-1.61"
      transform="translate(-0.91 -0.02)"
      fill="#353535"
    />
    <path
      d="M9.94,16.26h0a12.17,12.17,0,0,0,.49-1.61,8.48,8.48,0,0,0,.22-1.31,2.78,2.78,0,0,0-.06-.54h0a5.31,5.31,0,0,0-1.44-1.52,3,3,0,0,0-1.88-.63,3.43,3.43,0,0,0-2.1.69A9.63,9.63,0,0,0,3.5,12.89h0a8.87,8.87,0,0,1,1.67-1.55,3.37,3.37,0,0,1,2.1-.69,3,3,0,0,1,1.88.62,5.31,5.31,0,0,1,1.44,1.52h0a2.78,2.78,0,0,1,.06.54,9.45,9.45,0,0,1-.22,1.3,12.06,12.06,0,0,1-.49,1.62h0"
      transform="translate(-0.91 -0.02)"
      fill="#353535"
    />
    <path
      d="M45.35,8.23s2.09,1.51-.93,1.65a70.57,70.57,0,0,0-25,5.72S34.18,2.06,45.35,8.23"
      transform="translate(-0.91 -0.02)"
      fill="#353535"
    />
    <path
      d="M30.35,11.72c-1,.22-.44.08-.45,0a3.13,3.13,0,0,0,.45,0"
      transform="translate(-0.91 -0.02)"
      fill="#353535"
    />
    <path
      d="M26.8,13.56a70.2,70.2,0,0,1,8.31-1.85c4.27-.72,8.73-.9,9.25-1a76.33,76.33,0,0,0-8.14.69c-4.12.54-8.3,1.63-8.95,1.73a77.93,77.93,0,0,1,7.79-1.72c4-.69,8.26-.94,8.95-1.08,0,0-3.6.09-7.39.59S28.87,12.34,28,12.48c0,0,2.71-.62,3.43-.81l-1.27.23c.67-.15,1.35-.32,2-.45l1.13-.19c-.34,0-2.1.34-3,.46l3.88-.82s3.44-.63,9.52-1c.71-.08,1.68,0,2.2-.53.1-.81-1-1.22-1.74-1.55a13.05,13.05,0,0,0-5.74-.91c-4.18.25-8.62,2.26-12.73,5.24,0,0,0,.42-.31-.09l-.34-.35-.39-.17-.13-.33c.08.12.25-.77,6.67-3.77a19.06,19.06,0,0,1,6.51-1.72,15.82,15.82,0,0,1,4.5.36c1.41.52,2.72.44,4.48,2.32a1.47,1.47,0,0,1,0,1.56,1.78,1.78,0,0,1-1,.67,6.73,6.73,0,0,1-1.48.2c-.85,0-1.71.09-2.58.15A84.92,84.92,0,0,0,26.8,13.56"
      transform="translate(-0.91 -0.02)"
      fill="#353535"
    />
    <path
      d="M24.31,11.16h0c.27,0,6.72-5.54,15.22-5.55h.69a14.05,14.05,0,0,1,3,.58,10.22,10.22,0,0,1,3,1.41A2.43,2.43,0,0,1,47,8.74a1,1,0,0,1,.08.4,1.63,1.63,0,0,1-.41,1,1.08,1.08,0,0,1-.66.46h0a6.61,6.61,0,0,1-2.05.31,81.75,81.75,0,0,0-10.32,1.21h0c-.13,0-5,1-7.87,1.87h0c2.86-.84,7.74-1.87,7.87-1.87h0A83.77,83.77,0,0,1,44,10.93a6.87,6.87,0,0,0,2.05-.3h0a1.65,1.65,0,0,0,1.07-1.49,1,1,0,0,0-.08-.4,2.53,2.53,0,0,0-.78-1.13,10.63,10.63,0,0,0-3-1.41,13.57,13.57,0,0,0-3-.57h-.69c-8.5,0-14.95,5.55-15.22,5.55h0"
      transform="translate(-0.91 -0.02)"
      fill="#353535"
    />
    <path
      d="M30.38,7.63l-1.26.62c.41-.21.83-.42,1.26-.62"
      transform="translate(-0.91 -0.02)"
      fill="#353535"
    />
    <path
      d="M29.12,8.25c-.9.46-1.73.93-2.44,1.35.71-.43,1.54-.89,2.44-1.35"
      transform="translate(-0.91 -0.02)"
      fill="#353535"
    />
    <path d="M26.67,9.6l-.37.22.37-.22" transform="translate(-0.91 -0.02)" fill="#353535" />
    <path d="M26,10l-.47.3L26,10" transform="translate(-0.91 -0.02)" fill="#353535" />
    <path d="M25.47,10.33l-.27.18.27-.18" transform="translate(-0.91 -0.02)" fill="#353535" />
    <path d="M25,10.67l-.21.14.21-.14" transform="translate(-0.91 -0.02)" fill="#353535" />
    <path d="M24.75,10.81l-.17.12.17-.12" transform="translate(-0.91 -0.02)" fill="#353535" />
    <path d="M24.45,11l-.08.07.08-.07" transform="translate(-0.91 -0.02)" fill="#353535" />
    <polygon points="23.43 11.11 23.41 11.14 23.41 11.15 23.41 11.14 23.43 11.11" fill="#353535" />
    <path
      d="M43.28,10.44c-1.78,0-12.53,1.37-14.94,2.3h0c2.41-.94,13.16-2.3,14.94-2.31.16,0,.25,0,.25,0h0s-.09,0-.25,0"
      transform="translate(-0.91 -0.02)"
      fill="#353535"
    />
    <path
      d="M12.26,25.22s1.47-.59,1.28,2S12.38,41.62,6.07,47.3c0,0-1,.57-.86-2.59s3.2-18.21,7.05-19.49"
      transform="translate(-0.91 -0.02)"
      fill="#353535"
    />
    <path
      d="M10.9,39.85a2.12,2.12,0,0,1-.26.58c.09-.19.18-.39.26-.58"
      transform="translate(-0.91 -0.02)"
      fill="#353535"
    />
    <path d="M9.32,43.05Z" transform="translate(-0.91 -0.02)" fill="#353535" />
    <path
      d="M9.42,42.65c-.63,1.24-.5.51-.4.56a2.78,2.78,0,0,0,.4-.56"
      transform="translate(-0.91 -0.02)"
      fill="#353535"
    />
    <path d="M8,45.16,8,45.09s-.06.07-.07.07" transform="translate(-0.91 -0.02)" fill="#353535" />
    <path
      d="M10.64,40.43a2.12,2.12,0,0,0,.26-.58c-.08.19-.17.39-.26.58M7,32.09A28.87,28.87,0,0,1,8.9,27.61a10.67,10.67,0,0,1,1.41-2.09,4.16,4.16,0,0,1,1.26-1,1.81,1.81,0,0,1,2.27.23c1,1.41.53,2.48.54,3.39s-.21,1.94-.36,2.91a37.71,37.71,0,0,1-3.11,10.7,18.31,18.31,0,0,1-3.19,4.8,24.44,24.44,0,0,0,4.53-8.18A43,43,0,0,0,14.34,28a46.45,46.45,0,0,1-1.79,9.1c-1.25,4.58-4.19,8.68-4.86,9.09A23.13,23.13,0,0,0,12,38.33a36.69,36.69,0,0,0,1.91-10,46.72,46.72,0,0,1-1.61,8.14A23.6,23.6,0,0,1,8,45.09a19.59,19.59,0,0,0,2-3.21c-.2.4-.47.78-.7,1.17a22,22,0,0,0,1-2c.09-.16.17-.33.25-.5-.33.62-.82,1.52-1.17,2.09.32-.63.84-1.78,1.66-3.8a37,37,0,0,0,2.31-10.26,8.85,8.85,0,0,0,0-2.62c-.21-1.15-1.55-.7-2.12.07-1.37,1.45-2.12,3.57-2.86,5.75A56.72,56.72,0,0,0,6.69,39c-.35,2.39-1,5.66-.41,7.54l-.19.16a1.24,1.24,0,0,0-.29.39.4.4,0,0,0,.13.38,1,1,0,0,1-.14.34c.13.09-1-.11-1.08-1.45s-.08-3.4.62-7.18A44.16,44.16,0,0,1,7,32.09"
      transform="translate(-0.91 -0.02)"
      fill="#353535"
    />
    <path
      d="M7.42,46.86l.28-.26a1.36,1.36,0,0,1-.28.26"
      transform="translate(-0.91 -0.02)"
      fill="#353535"
    />
    <path d="M6.28,46.53c.17-.13,0,.06,0,0Z" transform="translate(-0.91 -0.02)" fill="#353535" />
    <path
      d="M6.37,47.84h0a1,1,0,0,1-.46.12,1.19,1.19,0,0,1-.58-.17h0a2.14,2.14,0,0,1-.75-1.49,8.49,8.49,0,0,1-.08-1.17,23.53,23.53,0,0,1,.29-3.2A61.34,61.34,0,0,1,7.86,29.57h0a21.51,21.51,0,0,1,1.47-2.93h0c.68-.78,1.1-2,3.23-2.5h0c1.55,0,2,1.6,2,2.25v.35a15.66,15.66,0,0,1-.11,1.76,42.82,42.82,0,0,1-2.65,11.58h0c0,.23-2.32,5.61-5.22,7.78h0c2.9-2.18,5.22-7.55,5.22-7.79h0A42.31,42.31,0,0,0,14.47,28.5c0-.56.11-1.1.11-1.76,0-.1,0-.21,0-.32v0c0-.65-.45-2.26-2-2.26h0c-2.14.47-2.55,1.72-3.23,2.51h0a20.13,20.13,0,0,0-1.47,2.93h0A61.26,61.26,0,0,0,4.79,41.92a23.8,23.8,0,0,0-.29,3.21,7.09,7.09,0,0,0,.08,1.17,2.1,2.1,0,0,0,.75,1.5h0a1.27,1.27,0,0,0,.58.16,1,1,0,0,0,.46-.12h0"
      transform="translate(-0.91 -0.02)"
      fill="#353535"
    />
    <path
      d="M14.46,28.5v.08h0V28.5c0-.29.15-.7.15-1.4a6.57,6.57,0,0,0-.27-1.8,2,2,0,0,0-1.68-1.19h-.1l-.31,0,.31,0h.1a2,2,0,0,1,1.68,1.19,6.57,6.57,0,0,1,.27,1.8c0,.7-.14,1.11-.14,1.4"
      transform="translate(-0.91 -0.02)"
      fill="#353535"
    />
    <path d="M11.88,24.25l.23-.07-.23.07" transform="translate(-0.91 -0.02)" fill="#353535" />
    <path
      d="M11.35,24.52a4.24,4.24,0,0,1-.44.27h0a3.56,3.56,0,0,0,.45-.27"
      transform="translate(-0.91 -0.02)"
      fill="#353535"
    />
    <path d="M10.91,24.79l-.28.25.27-.25Z" transform="translate(-0.91 -0.02)" fill="#353535" />
    <path
      d="M10.63,25c-.08.08-.17.16-.25.25a3,3,0,0,1,.25-.25"
      transform="translate(-0.91 -0.02)"
      fill="#353535"
    />
    <path
      d="M9.71,26.09a8.27,8.27,0,0,0-.54.82A26.18,26.18,0,0,0,7.32,31c-.15.41-.27.77-.36,1.06a26.87,26.87,0,0,1,2.2-5.12,9,9,0,0,1,.55-.82"
      transform="translate(-0.91 -0.02)"
      fill="#353535"
    />
    <path
      d="M6.91,32.17c0,.09,0,.17-.07.24s0-.15.07-.24"
      transform="translate(-0.91 -0.02)"
      fill="#353535"
    />
    <path
      d="M6.81,32.51a1.42,1.42,0,0,0,0,.16.58.58,0,0,1,0-.16"
      transform="translate(-0.91 -0.02)"
      fill="#353535"
    />
    <path
      d="M6.71,32.8h0c-.07.21-.14.44-.21.68.07-.24.14-.47.21-.68"
      transform="translate(-0.91 -0.02)"
      fill="#353535"
    />
    <path d="M6.43,33.72l-.15.51.15-.51" transform="translate(-0.91 -0.02)" fill="#353535" />
    <polygon points="5.46 47.82 5.46 47.82 5.45 47.83 5.46 47.82" fill="#353535" />
    <path
      d="M5.9,48a.94.94,0,0,0,.38-.08A.94.94,0,0,1,5.9,48a1.12,1.12,0,0,1-.63-.2h0a1.23,1.23,0,0,0,.63.2"
      transform="translate(-0.91 -0.02)"
      fill="#353535"
    />
    <path
      d="M4.72,42a24.82,24.82,0,0,0-.25,3,7.42,7.42,0,0,0,.08,1.19,4.57,4.57,0,0,0,.2.83,5.6,5.6,0,0,1-.21-.83A8.79,8.79,0,0,1,4.46,45a23.11,23.11,0,0,1,.26-3c.21-1.58.52-3.3.87-4.91l.27-1.19C5.4,37.81,5,40,4.72,42"
      transform="translate(-0.91 -0.02)"
      fill="#353535"
    />
    <path
      d="M13.94,28.92h0a49.28,49.28,0,0,1-1.4,7.34,26.74,26.74,0,0,1-4.13,8.87h0a26.54,26.54,0,0,0,4.13-8.87,44.9,44.9,0,0,0,1.09-5.09c.11-.68.19-1.25.24-1.64,0-.19,0-.35.05-.45v-.15h0"
      transform="translate(-0.91 -0.02)"
      fill="#353535"
    />
    <path
      d="M12.94,25.28a.17.17,0,0,1,.13.07.19.19,0,0,0-.13-.06.23.23,0,0,0-.15.05h0a.24.24,0,0,1,.15-.06"
      transform="translate(-0.91 -0.02)"
      fill="#353535"
    />
    <path
      d="M13.32,26.94a5.51,5.51,0,0,0-.1-1.21.93.93,0,0,0-.15-.38,3,3,0,0,1,.26,1.59,30.39,30.39,0,0,1-.8,6.12,32.21,32.21,0,0,1-2.94,8.66h0a32.73,32.73,0,0,0,2.94-8.66,29.58,29.58,0,0,0,.79-6.12"
      transform="translate(-0.91 -0.02)"
      fill="#353535"
    />
    <path
      d="M17.68,23.35c-1.28,1.74-1.93,16.22,6,24,0,0,1.83,1.7,1.83-1s-4.43-27.68-7.84-23"
      transform="translate(-0.91 -0.02)"
      fill="#353535"
    />
    <path
      d="M16.44,23.87s-.24-.44.32-.23l.5,0a2.64,2.64,0,0,1,.44-.12l.27.24c.23-.11-1,.54,0,8.94a38,38,0,0,0,2.17,7.49,23.37,23.37,0,0,0,2.46,4.4c.63,1.1,2.95,3.14,2,2.15a40.58,40.58,0,0,0-.75-6c-1.31-8.4-4.2-17.52-5.2-17.3-.1-.15.74.42,1.47,2.29a48.69,48.69,0,0,1,2.1,6.94c1.26,5.23,2.07,10.74,2.2,11.38.31,0-3.42-19.95-5.28-20.53.22-.29,2.29,4.08,3.33,9.08,1.2,4.92,2.05,10.15,2.28,11,.24,0-3-17.7-4.62-19.49a28.46,28.46,0,0,1,1.61,4.05c-.14-.51-.29-1-.46-1.54.3.81.56,1.63.81,2.46l.36,1.45s-1-3.92-1.09-4.21c-.1,0-.49-1.77,1.57,5.25,0,0,1.05,4.21,2.28,11.66.14.93.3,1.91.38,3a2.37,2.37,0,0,1-.33,1.58c-.53.48-1.19,0-1.6-.32a21.52,21.52,0,0,1-4.29-6,31.62,31.62,0,0,1-2.91-17.58"
      transform="translate(-0.91 -0.02)"
      fill="#353535"
    />
    <path
      d="M18.17,23.71l0,0c-.18,0-.47,1.64-.47,4.13,0,3.9.74,9.87,3.78,14.88h0a17.83,17.83,0,0,0,1.86,2.71l1.07,1.19a1.25,1.25,0,0,0,.41.28h0v0h0c0,.06,0,.28,0,.4v.1h0a1.06,1.06,0,0,0-.26-.23h0a28.61,28.61,0,0,0-.35-3.51c-.84-5.69-2.29-11.58-2.6-12.69h0c0-.05-.4-1.56-1-3.44-.36-1.44-1.67-3.93-2.1-3.93-.08,0-.13.09-.14.27h0c0-.18.05-.26.13-.26.43,0,1.74,2.48,2.09,3.92.65,1.91,1,3.44,1,3.44h0c.31,1.11,1.75,7,2.59,12.69a26.71,26.71,0,0,1,.35,3.51h0a.83.83,0,0,1,.27.23h0v-.1a3.67,3.67,0,0,1,0-.4h0v0h0a1.27,1.27,0,0,1-.4-.28l-1.07-1.19a17.49,17.49,0,0,1-1.86-2.71h0c-3-5-3.78-11-3.78-14.88a25.32,25.32,0,0,1,.16-3c.1-.72.22-1.13.3-1.12l0,0h0"
      transform="translate(-0.91 -0.02)"
      fill="#353535"
    />
    <path
      d="M24.15,43.52c0,.4.26,1.67.31,2.93,0,0,0,.07,0,.1a4,4,0,0,1-.08.4c0,.07,0,.12.12.17a.62.62,0,0,1,.26.23h0a1.41,1.41,0,0,1,0-.18c0-.17,0-.25,0-.29s0-.05,0-.05h0a.09.09,0,0,1-.08,0h0a16,16,0,0,1-1.56-1.63,22.31,22.31,0,0,1-3.2-5.72h0a34.9,34.9,0,0,1-2.15-9.82c-.05-.62-.08-1.22-.08-1.79a20.43,20.43,0,0,1,.21-3,3.55,3.55,0,0,1,.27-1.17v0h0v0a13,13,0,0,0-.48,4.14c0,.57,0,1.17.08,1.79a34.56,34.56,0,0,0,2.15,9.82h0a22.46,22.46,0,0,0,3.19,5.72,14.91,14.91,0,0,0,1.57,1.63h0a.1.1,0,0,0,.08.05h0s0,0,0,.05a2.12,2.12,0,0,1,0,.29c0,.12,0,.17,0,.18h0s-.05-.12-.26-.24a.15.15,0,0,1-.11-.16c0-.1.07-.23.07-.4a.34.34,0,0,0,0-.1c0-1.26-.28-2.53-.32-2.93h0"
      transform="translate(-0.91 -0.02)"
      fill="#353535"
    />
    <path
      d="M24.57,43h0v0c0-.76-2.72-15.6-4.6-18.42h0c1.88,2.82,4.6,17.66,4.6,18.42v0h0"
      transform="translate(-0.91 -0.02)"
      fill="#353535"
    />
    <path
      d="M25.53,47.38c.12,0,.17-.28.17-.74,0-3.4-2.91-17.4-3.56-18.66h0c.65,1.26,3.56,15.26,3.56,18.66,0,.46-.05.72-.16.74h0"
      transform="translate(-0.91 -0.02)"
      fill="#353535"
    />
    <path
      d="M16.77,6.41a2.46,2.46,0,0,0,0-.47,3.68,3.68,0,0,0-.06-.56,2.85,2.85,0,0,1,0-.29l0-.09c0-.07,0-.13,0-.19a2.16,2.16,0,0,0,0-.44.8.8,0,0,0,0-.31.87.87,0,0,1-.05-.22c0-.06,0-.07,0-.12s.12,0,.15-.11,0-.14-.07-.23,0-.17-.07-.25a1,1,0,0,0-.11-.34,1.47,1.47,0,0,0-.06-.14.89.89,0,0,1,0-.22c0-.17-.31-.36-.45-.44"
      transform="translate(-0.91 -0.02)"
      fill="#353535"
    />
  </svg>
);



// WEBPACK FOOTER //
// ./components/common/FooterLogoPP.jsx